// src/data/projects.js
// Shared by the desktop and mobile Project views/modal so the content
// only ever lives in one place.
const projects = [
  {
    title: 'Two Souls',
    tag: 'COUPLES APP',
    gradient: 'linear-gradient(135deg, #ff6b9d, #c44569)',
    technologies: ['Flutter', 'Node.js', 'Firebase', 'PostgreSQL'],
    description: [
      'Designed as an intimate, privacy-first sanctuary for couples in India with end-to-end encrypted messaging.',
      'Implemented Signal Protocol (X3DH and Double Ratchet) for military-grade message encryption and privacy.',
      'Built real-time push notifications using Firebase Cloud Messaging (FCM) for seamless communication.',
      'Integrated location sharing, music sync, and timeline features for couples to experience moments together.',
      'Added engagement stats and streaks system to encourage daily connection and intimacy.',
      'Developed comprehensive subscription model with tiered feature access.',
      'Redesigned full UI system for an intuitive, emotionally resonant user experience.',
      'Ensured rigorous test coverage across all core features and encryption flows.',
      'Conducted market research and positioning strategy for the Indian couples app space.',
      'Built scalable backend architecture with real-time data sync and state management.',
    ],
    projectImagesLink: 'https://drive.google.com/drive/folders/1JsoLPBHjIddOgmgvm_KOsEX8mnTk418-?usp=sharing',
  },
  {
    title: 'Fingo News',
    tag: 'STOCK MARKET AI',
    gradient: 'linear-gradient(135deg, #0f2027, #2c5364)',
    technologies: ['Next.js', 'Node.js', 'PostgreSQL', 'Prisma', 'Claude/OpenAI/Gemini APIs', 'Redis/NodeCache'],
    description: [
      'Created a production-grade NSE (National Stock Exchange) filing scraper with near-continuous polling and webhook-triggered updates.',
      'Implemented Next.js App Router with Incremental Static Regeneration (ISR) and on-demand revalidation for SEO optimization.',
      'Built dynamic Open Graph image generation for rich social media previews and improved sharing.',
      'Developed multi-provider AI support with intelligent fallback hierarchy (Claude → OpenAI → Gemini → OpenRouter).',
      'Created encrypted API key management UI for secure integration with multiple AI providers.',
      'Optimized stock screener with nightly precomputed technical indicators achieving sub-50ms response times.',
      'Built background sync workers and intelligent caching using NodeCache for real-time data availability.',
      'Developed content creation suite (Brand Story, Quote Post, Banner Generator, Canvas Post) with Canva-style UI.',
      'Implemented comprehensive sitemap generation and crawl budget optimization for search engine visibility.',
      'Built full-stack news platform with Fastify backend and React/Vite frontend for high-performance content delivery.',
    ],
    projectImagesLink: 'https://drive.google.com/drive/folders/1b5UDyS6_OJaXBg-Wc2sHAnTbzpXcHLcX?usp=sharing',
  },
  {
    title: 'ManSetu',
    tag: 'HEALTHTECH',
    gradient: 'linear-gradient(135deg, #00b894, #079992)',
    technologies: ['Full-stack Web & Mobile', 'Role-Based Access Control', 'Database Management'],
    description: [
      'Designed a comprehensive platform for wellbeing professionals (therapists, counselors, wellness coaches) to manage their practice.',
      'Implemented role-based access control with distinct workflows for practitioners, clients, and administrative staff.',
      'Built client management system for tracking sessions, progress notes, and therapeutic outcomes.',
      'Created scheduling and appointment management features with automated reminders and calendar sync.',
      'Developed billing and subscription management for practitioners to monetize their services.',
      'Enabled secure client-practitioner communication channels with privacy compliance.',
      'Built reporting and analytics dashboards for practitioners to track practice metrics and client outcomes.',
      'Designed responsive UI for both web and mobile platforms for on-the-go practice management.',
      'Implemented comprehensive data security and HIPAA-compliant infrastructure for sensitive health information.',
      'Created intuitive onboarding workflows for practitioners to quickly set up their digital practice.',
    ],
    projectImagesLink: 'https://drive.google.com/drive/folders/1CAhW_Et8NAHQYUuWMV1uPJBsb3xCLEp4?usp=sharing',
  },
  {
    title: 'No Bunk',
    tag: 'SCHOOL APP',
    gradient: 'linear-gradient(135deg, #1abc9c, #2ecc71)',
    technologies: ['Flutter', 'Node.js', 'Firebase', 'MongoDB', 'AWS EC2'],
    description: [
      'Developed an application with 5 distinct roles: Student, Parent, Teacher, Admin, and Driver.',
      'Implemented features such as result assigning and viewing, attendance tracking, and bus tracking.',
      'Added functionalities for awards management, report card generation, and dispute resolution.',
      'Provided event and notice management with real-time notifications for all users.',
      'Enabled direct chat between students and their mentors for better communication.',
      'Designed modules for creating and managing exam and school timetables.',
      'Built robust user management, allowing admins to add or remove users and manage permissions.',
      'Parents could view their child’s live bus status, assignments, results, and other updates.',
      'Used Node.js for the backend to ensure a scalable and efficient system.',
      'Created a responsive and user-friendly portal for managing school operations seamlessly.',
    ],
    projectImagesLink: 'https://drive.google.com/drive/folders/1OpOa7zzI1R-BQ8mxUTI1I-AVzTJpdWU1?usp=sharing',
  },
  {
    title: 'Admin Dashboard',
    tag: 'SCHOOL ADMIN',
    gradient: 'linear-gradient(135deg, #3498db, #00aaff)',
    technologies: ['Flutter', 'Node.js', 'Firebase', 'MongoDB', 'AWS EC2'],
    description: [
      'Designed and developed a web-based admin dashboard with features to streamline school operations.',
      'Implemented user management, including adding, updating, and removing users.',
      'Added functionality to create certificates and ID cards for students and staff.',
      'Developed features to manage student-related data, such as fees, certificates, late fee payments, and notifications.',
      'Digitized financial management, eliminating the need for paperwork and enabling inventory management through the portal.',
      'Integrated teacher salary management, allowing admin to track salary statuses directly from the portal.',
      'Provided features to track vendor transactions, including sales and purchases, within the system.',
      'Included bus tracking and bus assignment features for effective transportation management.',
      'Supported bulk user uploads via Excel sheets for efficient data management.',
      'Added a module to manage user query form statuses and streamline query resolutions.',
      'Equipped the portal with additional tools to further simplify school administrative tasks.',
    ],
    projectImagesLink: 'https://drive.google.com/drive/folders/1pWJriciP_M6_txESigJYqqLY7kLKr9r1?usp=sharing',
  },
  {
    title: 'E Learning Platform',
    tag: 'EDUCATION',
    gradient: 'linear-gradient(135deg, #e74c3c, #c0392b)',
    technologies: ['Flutter', 'Node.js', 'Firebase', 'MongoDB', 'AWS EC2'],
    description: [
      'Implemented features to start trial courses and provide a seamless onboarding experience.',
      'Added functionality for students to take assignments and quizzes within the portal.',
      'Enabled chat support for connecting with mentors, the support team, or the sales team.',
      'Integrated live doubt support to assist students in real time.',
      'Developed a store screen for purchasing new courses easily.',
      'Introduced a daily quiz feature, rewarding users with points upon completion.',
      'Created a rewards points screen for users to track and redeem their earned points.',
      'Added a certificate screen for students to view and download their course certificates.',
      'Implemented profile editing functionality for users to update their information.',
      'Provided dark and light mode options for better user accessibility and preferences.',
      'Integrated video course streaming with support for both vdoCipher videos and YouTube.',
    ],
    projectImagesLink: 'https://drive.google.com/drive/folders/1B-vT13BvGl2MCyLcQUD7_PDe0OPQnBT_?usp=sharing',
  },
  {
    title: 'School Management App',
    tag: 'SELF PROJECT',
    gradient: 'linear-gradient(135deg, #f1c40f, #f39c12)',
    technologies: ['Flutter', 'GoLang', 'MongoDB', 'AWS S3', 'EC2'],
    description: [
      'Developed a comprehensive school management system with dedicated user interfaces for Admin, Teachers, Students, and Parents.',
      'Implemented GetX for efficient state management across the frontend.',
      'Used GoLang for backend API services, ensuring fast and scalable performance.',
      'Utilized AWS S3 for image storage and AWS EC2 for hosting, improving reliability.',
      'Admin functionalities included user management, fee tracking, notice creation, and timetable management.',
      'Teachers could take attendance, assign homework, and manage notices for students.',
      'Students had access to view attendance, assignments, timetables, and notices, while parents could monitor student progress and view important updates.',
    ],
    projectImagesLink: 'https://drive.google.com/drive/folders/1YPNg7iJzhKXuH4ZtgLtmGf6i6AVu9VPF?usp=sharing',
  },
  {
    title: 'Data Card Application',
    tag: 'SECURITY',
    gradient: 'linear-gradient(135deg, #9b59b6, #8e44ad)',
    technologies: ['Flutter', 'Node.js', 'Firebase', 'AWS', 'IPFS'],
    description: [
      'Developed a secure document management system for sharing documents with view-only access through Data Cards.',
      'Implemented two-factor authentication (2FA) to ensure secure sharing and access control.',
      'Grouped documents into Data Cards for better organization and tracking.',
      'Designed a two-level security system using IPFS to store documents securely and ensure immutability.',
      'Integrated Firebase authentication for user access management and AWS EC2 for backend hosting.',
      'The system provided seamless upload, storage, and retrieval of documents while enforcing strict access policies.',
    ],
    projectImagesLink: 'https://drive.google.com/drive/folders/1YiaUEgSga-NBLXpkaYKTfO5ndLYpCF0l?usp=sharing',
  },
];

export default projects;
